import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import ptLocale from '@fullcalendar/core/locales/pt-br'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import acessos from '../mixins/acessos'

dayjs.extend(utc)
dayjs.extend(timezone)

const hoje = new Date()
hoje.setHours(0, 0, 0, 0)

export default {
	props: [
		'eventos',
		'hidenUsuarioSelecionado',
		'hidenMultiselectClientes',
		'bgColorCalendario',
		'optionsClientes',
		'usuarioSelecionado',
	],
	emits: [
		'click:eventoCalendario',
		'click:novoEvento',
		'doubleClick:eventoCalendario',
		'update:usuarioSelecionado',
	],
	data() {
		return {
			calendar: null,
			clickTimeout: null,
			optionsClientesFiltradas: [...this.optionsClientes],
			tituloCalendario: '',
			viewAtual: 'dayGridMonth',
		}
	},
	watch: {
		eventos: {
			handler(newValue) {
				if (this.calendar) {
					const eventosConvertidos = this.convertEventosParaCalendario(newValue)
					this.calendar.removeAllEvents()
					this.calendar.addEventSource(eventosConvertidos)
				}
			},
			deep: true,
		},
	},
	methods: {
		filterClientes(val, update, abort) {
			if (val === '') {
				update(() => {
					this.optionsClientesFiltradas = this.optionsClientes
				})
				return
			}

			update(() => {
				const search = val.toLowerCase()

				this.optionsClientesFiltradas = this.optionsClientes.filter(
					(option) => {
						if (typeof option === 'object' && option.label) {
							return option.label.toLowerCase().indexOf(search) > -1
						}
						return option.toLowerCase().indexOf(search) > -1
					}
				)

				console.log('optionsClientesFiltradas', this.optionsClientesFiltradas)
			})
		},
		onUsuarioSelecionadoChange(valor) {
			this.$emit('update:usuarioSelecionado', valor)
		},
		initCalendario() {
			let calendarEl = document.getElementById('calendar')
			this.calendar = new Calendar(calendarEl, {
				plugins: [dayGridPlugin, timeGridPlugin, listPlugin],
				locale: ptLocale,
				timeZone: 'UTC',
				initialView: 'dayGridMonth',
				displayEventTime: true,
				customButtons: {
					buttonNovoEvento: {
						text: 'Novo Evento',
						click: () => {
							this.$emit('click:novoEvento')
						},
					},
				},
				/* headerToolbar: {
					left: this.hidenUsuarioSelecionado
						? 'prev,next today'
						: 'prev,next today buttonNovoEvento',
					center: 'title',
					right: 'dayGridMonth',
					// right: 'dayGridMonth,timeGridWeek,listWeek', 
				},*/

				headerToolbar: false,

				events: this.convertEventosParaCalendario(this.eventos),
				eventContent: (arg) => {
					const agora = dayjs().tz('America/Sao_Paulo')
					const dataEventoFim = dayjs(arg.event.extendedProps.dataEventoFim)
					const corBolinha = agora.isAfter(dataEventoFim)
						? 'bg-[#969ea6]'
						: 'bg-[#3f9df8]'

					const timeText = arg.event.extendedProps.isDiaInteiro
						? 'Dia Inteiro'
						: this.padTimeText(arg.timeText)

					let htmlContent = ''
					if (this.calendar.view.type === 'dayGridMonth') {
						htmlContent = `
							<div class="flex items-start !gap-x-4 w-full overflow-x-hidden p-4 cursor-pointer">
								<div class="flex items-center !gap-x-2">
									<span class="inline-block size-8 rounded-full ${corBolinha} mr-2"></span>
									<label class="text-paragraph-3">${timeText}</label>
								</div>
								<label> - </label>
								<p class="
									text-paragraph-3 
									text-bold 
									break-words 
									whitespace-normal">${arg.event.title}</p>
							</div>
						`
					} else {
						htmlContent = `
						<a href="#" class="block !no-underline">	
							<div class="w-full overflow-x-hidden p-4 cursor-pointer">
								<p class="
									text-paragraph-3 
									text-bold 
									break-words 
									whitespace-normal">${arg.event.title}</p>
							</div>
						</a>
						`
					}

					return {
						html: htmlContent,
					}
				},
				eventDidMount: (info) => {
					if (info.event.extendedProps.isEventoPassado) {
						info.el.classList.add('evento-passado')
					}
				},
				eventClick: (info) => {
					info.jsEvent.preventDefault()
					info.jsEvent.stopPropagation()

					if (this.clickTimeout && !this.hidenUsuarioSelecionado) {
						clearTimeout(this.clickTimeout)
						this.clickTimeout = null
						this.$emit('doubleClick:eventoCalendario', info)
						return
					}
					this.clickTimeout = setTimeout(() => {
						clearTimeout(this.clickTimeout)
						this.$emit('click:eventoCalendario', info)
						this.clickTimeout = null
					}, 500)
				},
			})
			this.calendar.render()
			this.tituloCalendario = this.calendar.view.title
			this.viewAtual = this.calendar.view.type
			console.log(this.calendar.view.title)
			return this.calendar
		},
		convertEventosParaCalendario(eventos) {
			const eventosConvertidos = eventos?.map((evt) => {
				let dataEventoInicio, dataEventoFim, start, end
				const classNames = []

				classNames.push(`evento-calendario`)

				if (evt.isDiaInteiro) {
					dataEventoInicio = dayjs
						.utc(evt.dataEventoInicio)
						.format('YYYY-MM-DDT00:00:00')
					dataEventoFim = dayjs
						.utc(evt.dataEventoFim)
						.format('YYYY-MM-DDT00:00:00')
					start = dayjs.utc(evt.start).format('YYYY-MM-DDT00:00:00')
					end = dayjs.utc(evt.end).format('YYYY-MM-DDT00:00:00')
				} else {
					dataEventoInicio = dayjs
						.utc(evt.dataEventoInicio)
						.tz('America/Sao_Paulo')
						.format()
					dataEventoFim = dayjs
						.utc(evt.dataEventoFim)
						.tz('America/Sao_Paulo')
						.format()
					start = dayjs.utc(evt.start).tz('America/Sao_Paulo').format()
					end = dayjs.utc(evt.end).tz('America/Sao_Paulo').format()
				}

				return {
					...evt,
					dataEventoInicio,
					dataEventoFim,
					start,
					end,
					classNames,
				}
			})

			return eventosConvertidos
		},
		padTimeText(timeText) {
			if (/^\d{1,2}$/.test(timeText)) {
				return `${timeText}:00`
			}
			return timeText
		},

		setEventosCalendario() {
			if (this.calendar) {
				document
					.querySelector('[data-calendar="btn-voltar"]')
					?.addEventListener('click', () => {
						this.calendar.prev()

						this.$nextTick(() => {
							this.tituloCalendario = this.calendar.view.title
						})
					})

				document
					.querySelector('[data-calendar="btn-avancar"]')
					?.addEventListener('click', () => {
						this.calendar.next()

						this.$nextTick(() => {
							this.tituloCalendario = this.calendar.view.title
						})
					})

				document
					.querySelector('[data-calendar="btn-hoje"]')
					?.addEventListener('click', () => {
						this.calendar.today()

						this.$nextTick(() => {
							this.tituloCalendario = this.calendar.view.title
						})
					})

				document
					.querySelector('[data-calendar="btn-novo-evento"]')
					?.addEventListener('click', () => {
						this.$emit('click:novoEvento')
					})

				document
					.querySelector('[data-calendar="btn-mes"]')
					?.addEventListener('click', () => {
						this.calendar.changeView('dayGridMonth')
						this.viewAtual = 'dayGridMonth'

						this.$nextTick(() => {
							this.tituloCalendario = this.calendar.view.title
						})
					})

				document
					.querySelector('[data-calendar="btn-semana"]')
					?.addEventListener('click', () => {
						this.calendar.changeView('listWeek')
						this.viewAtual = 'listWeek'

						this.$nextTick(() => {
							this.tituloCalendario = this.calendar.view.title
						})
					})

				document
					.querySelector('[data-calendar="btn-dia"]')
					?.addEventListener('click', () => {
						this.calendar.changeView('listDay')
						this.viewAtual = 'listDay'

						this.$nextTick(() => {
							this.tituloCalendario = this.calendar.view.title
						})
					})
			}
		},
	},
	mounted() {
		this.initCalendario()
		this.setEventosCalendario()
	},
	template: `
	<div class="w-full h-full space-y-20">
		<div class="flex items-center justify-between w-full">
			<div class="flex items-center justify-between max-w-max gap-8">
				<div class="space-x-8">
					<q-btn icon="arrow_back_ios" size="8px" color="primary" data-calendar="btn-voltar" />
					<q-btn icon="arrow_forward_ios" size="8px" color="primary" data-calendar="btn-avancar"/>
				</div>
				<q-btn label="Hoje" color="primary" data-calendar="btn-hoje"/>
				<q-btn v-if="!hidenUsuarioSelecionado" label="Novo Evento" color="primary" data-calendar="btn-novo-evento"/>

				<q-select
					v-if="!hidenMultiselectClientes"
					v-model="usuarioSelecionado" 
					use-input
    				input-debounce="300" 
					clearable
					label="Selecione o Officer" 
					label-color="neutral-70" 
					autocomplete="off"
					:options="optionsClientesFiltradas"
					class="calendar-header-select w-min"
					@update:model-value="onUsuarioSelecionadoChange"
					@filter="filterClientes"/>
			
			</div>

			<div :class="{'flex-1 pl-120': !hidenMultiselectClientes}">
				<h2 class="text-title-3 text-gray-700 !w-max">{{tituloCalendario}}</h2>
			</div>

			<div class="flex items-center gap-x-16 min-w-max">
				<q-btn label="Mês" color="primary" data-calendar="btn-mes"/>
				<q-btn label="Semana" color="primary" data-calendar="btn-semana"/>
				<q-btn label="Dia" color="primary" data-calendar="btn-dia"/>
			</div>
		</div>
        <div id="calendar"></div>
	</div>
    `,
}
